import { takeLatest, all, put, select, call } from 'typed-redux-saga';
import { getApiParams } from 'api';
import { selectPageModelCategoryId, selectPageModelRegionId } from 'store/pageModel';
import {
	fetchConfiguratorsSuccess,
	fetchConfiguratorsRequest,
	fetchConfiguratorsFailed,
	fetchRatingRequest,
	fetchRatingSuccess,
	fetchRatingFailed,
} from './slice';
import { selectConfiguratorsIds } from './selectors';
import { FetchConfiguratorsParams } from './types';
import { fetchConfigurators, fetchRating } from './api';

export function* getConfigurators() {
	try {
		const regionCode = yield* select(selectPageModelRegionId);
		const categoryId = yield* select(selectPageModelCategoryId);

		const { url, config } = yield* getApiParams(
			'/services-platform/v0/slp/online-offers-by-category-id',
		);
		const params: FetchConfiguratorsParams = { regionCode, categoryId };

		const data = yield* call(fetchConfigurators, url, params, config);
		yield* put(
			fetchConfiguratorsSuccess({
				data,
			})
		);
	} catch (error) {
		yield console.log(error);
		yield* put(
			fetchConfiguratorsFailed({
				error: { code: error?.status || 500, message: error?.message || null },
			})
		);
	}
}

export function* getRating() {
	try {
		const regionCode = yield* select(selectPageModelRegionId);
		const configuratorIds = yield* select(selectConfiguratorsIds);

		const { url, config } = yield* getApiParams('/services-platform/v0/slp/ratings:search');
		const params = {
			regionCode,
			configuratorIds,
		};

		const data = yield* call(fetchRating, url, params, config);

		yield* put(
			fetchRatingSuccess({
				data,
			})
		);
	} catch (error) {
		yield* put(
			fetchRatingFailed({
				error: { code: error?.status || 500, message: error?.message || null },
			})
		);
	}
}

export function* configuratorsListingRootSaga() {
	return yield* all([
		takeLatest(fetchConfiguratorsRequest, () => getConfigurators()),
		takeLatest(fetchRatingRequest, () => getRating()),
	]);
}
